import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OtaBatchDetailsComponent } from './ota-batch-details.component';

const routes: Routes = [
  {
    path: 'ota-batch-view',
    data: { name: 'View Device Batch', isTab: false },
    component: OtaBatchDetailsComponent,
  },
  {
    path: 'ota-batch-view/:otaRefId',
    data: { name: 'View Device Batch', isTab: false },
    component: OtaBatchDetailsComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchDetailsRoutingModule {}
